const AntdAppConfig = {
  notification: {
    stack: false,
    duration: 0,
    placement: "topLeft",
  },
};

export default AntdAppConfig;
